import { createFileRoute } from "@tanstack/react-router";

import { SnapShotSettings } from "../components/settings/SnapShotSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

function SettingsSnapShotRoute() {
  return <SnapShotSettings />;
}

export const Route = createFileRoute("/settings/snap-shot")({
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/snap-shot"),
  component: SettingsSnapShotRoute,
});
